export const MOBILE_MASK_Z_INDEX = 1000;
export const MOBILE_POPUP_Z_INDEX = 1050;
